import Base from './base';

const getBridge = async () => {
  const Wechat = (await import('./wechat')).default;
  const { IS_WECHAT } = (await import('@/constants'));
  if (IS_WECHAT) {
    return new Wechat();
  }
  return new Base();
};

export default getBridge;
